@if (visible()) {
<div class="toast" [ngClass]="[variant(), position()]">

  <!-- Prefix Icon -->
  @if (showPrefixIcon()) {
  <div class="toast-icon">

    @switch (variant()) {

    @case ('info') {
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <rect x="11" y="10.5" width="2" height="6.5" rx="1" fill="#fff" />
      <circle cx="12" cy="7.5" r="1.2" fill="#fff" />
    </svg>
    }

    @case ('success') {
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path d="M8 12.4L10.9 15.2L16 9.4" stroke="#fff" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" fill="none" />
    </svg>
    }

    @case ('warning') {
    <svg viewBox="0 0 24 24">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
        fill="currentColor" />
      <rect x="11" y="8.5" width="2" height="6" rx="1" fill="#fff" />
      <circle cx="12" cy="17.3" r="1.2" fill="#fff" />
    </svg>
    }
    @case ('error') {
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <rect x="11" y="6.5" width="2" height="7" rx="1" fill="#fff" />
      <circle cx="12" cy="16.5" r="1.2" fill="#fff" />
    </svg>
    }

    }

  </div>
  }

  <!-- Content -->
  <div class="toast-content">

    <div class="toast-title">
      {{ title() }}
    </div>

    @if (description().trim()) {
    <div class="toast-description">
      {{ description() }}
    </div>
    }

  </div>

  <!-- Action -->
  @if (showAction() && actionLabel()) {
  <button class="toast-action" (click)="onAction()">

    {{ actionLabel() }}

  </button>
  }

  <!-- Close -->
  @if (showClose()) {
  <button class="toast-close" (click)="onClose()">

    <svg viewBox="0 0 12 12">
      <path d="M2.5 2.5L9.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />

      <path d="M9.5 2.5L2.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>

  </button>
  }

</div>
}